module.exports = __webpack_public_path__ + "static/media/logo.c852fc4a.svg";